import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function LogoAuthentication({
  domain,
  langcode,
  source,
  sourceSmall,
  username,
  profileHref,
  helperLinks,
  hasAuthentication,
  isAuthenticated,
  onLogin,
  onLogout
}) {
  const { t } = useTranslation();

  const [isMobileViewport, setIsMobileViewport] = useState(false);

  useLayoutEffect(() => {
    setIsMobileViewport(window.innerWidth < 960);
  }, [window.innerWidth]);

  return (
    <div className={'branded-masthead js-branded-masthead page--' + langcode}>
      <div className="branded-masthead__content">
        <div className="content__logos">
          <a
            href="/"
            title={t(`styleguide:${domain}_masthead_logo_title`)}
            aria-label={t(`styleguide:${domain}_masthead_logo_title`)}
          >
            <img
              className="logos__logo"
              srcSet={`${sourceSmall} 480w, ${sourceSmall} 960w`}
              src={source}
              sizes="(max-width: 480px) 480px, 960px"
              alt={t(`styleguide:${domain}_masthead_logo_alt`)}
            />
          </a>
        </div>
        <div
          className="content__helper-menu js-helper-nav"
          aria-hidden={isMobileViewport}
          hidden={isMobileViewport || undefined}
        >
          {hasAuthentication && !isAuthenticated && (
            <a href={'#'} className={'button button--secondary ignore-external helper-menu__sign-in'} onClick={onLogin}>
              {t('styleguide:sign_in')}
            </a>
          )}
          {hasAuthentication && isAuthenticated && (
            <>
              {/* {config.auth.profile &&
                config.auth.profile[Language.currentLanguage] && ( */}
              <a
                href={profileHref}
                className={
                  'button button--secondary button--icon icon--user icon--left button--as-link ignore-external helper-menu__account'
                }
              >
                {username}
              </a>
              {/* )} */}
              {/* {!config.auth.profile && (
                <span
                  className={
                    "button button--secondary button--icon icon--user icon--left button--as-link ignore-external helper-menu__account"
                  }
                >
                  {name}
                </span>
              )} */}
              <a
                href={'#'}
                className={'button button--secondary ignore-external helper-menu__sign-out'}
                onClick={onLogout}
              >
                {t('styleguide:sign_out')}
              </a>
            </>
          )}
          <ul>
            {helperLinks.map((item, index) => (
              <li key={index} className="is-helper">
                <a href={item.href}>{item.text}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

LogoAuthentication.propTypes = {
  /**
   * The domain
   */
  domain: PropTypes.string,
  /**
   * The language code
   */
  langcode: PropTypes.string,
  /**
   * The logo source
   */
  source: PropTypes.string,
  /**
   * The small logo source
   */
  sourceSmall: PropTypes.string,
  /**
   * The username
   */
  username: PropTypes.string,
  /**
   * The profile link
   */
  profileHref: PropTypes.string,
  /**
   * The helper links
   */
  helperLinks: PropTypes.arrayOf(PropTypes.shape({ href: PropTypes.string, text: PropTypes.string })),
  /**
   * The authentication flag
   */
  hasAuthentication: PropTypes.bool,
  /**
   * The authenticated flag
   */
  isAuthenticated: PropTypes.bool,
  /**
   * The login handler
   */
  onLogin: PropTypes.func,
  /**
   * The logout handler
   */
  onLogout: PropTypes.func
};

export default LogoAuthentication;
